import { Component, input } from '@angular/core';
import { SharedModule } from '@app/modules/shared.module';
import { Repas } from '@app/models/carnet-liaison';
import { CarnetHeureFormatPipe } from '../../carnet-liaison.pipe';

@Component({
  selector: 'app-carnet-repas',
  templateUrl: './carnet-repas.component.html',
  styleUrl: './carnet-repas.component.scss',
  standalone: true,
  imports: [SharedModule, CarnetHeureFormatPipe],
})
export class CarnetRepasComponent {
  data = input.required<Repas>();

  getHydratationLabel(): string | null {
    const r = this.data()?.radio_hydratation;
    if (!r) return null;
    if (r.plusieursFois) return 'Plusieurs fois dans la journée';
    if (r.auRepas) return 'Au repas uniquement';
    if (r.pasBu) return "N'a pas bu";
    return null;
  }
}
